import React, { useContext } from 'react'
import { GlobalContext } from '../Context/GlobalState'

const IncomeExpenses = () => {
  const { transactions } = useContext(GlobalContext);

  const amounts = transactions.map(transaction => transaction.amount);

  const income = amounts.filter(item => item > 0).reduce((acc, item) => (acc += item),0).toFixed(2);

  const expense = (amounts.filter(item => item < 0).reduce((acc, item) => (acc+=item),0)*-1).toFixed(2);

  return (
    <div className="income-expense">
        <div>
            <h4>Income</h4>
            <p id="add-money" class="add money">{income}</p>
        </div>
        <div>
            <h4>Expenses</h4>
            <p class="deduct money">{expense}</p>
        </div>
      
    </div>
  )
}

export default IncomeExpenses
